import { getSearchString } from "../helpers/search/search.qwik.mjs";
import { isIframe } from "./is-iframe.qwik.mjs";
function isEditing(search) {
  return isIframe() && // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  getSearchString(search || window.location.search).indexOf("builder.frameEditing=") !== -1;
}
export {
  isEditing
};
